import {Outlet, Navigate, useLocation} from "react-router-dom";
import {AuthContext} from "./authentication.provider";
import {useContext} from "react";
import {LoadingComponent} from "../components";

export const ProtectedRouteProvider = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("AuthContext not found. Wrap your app with AuthProvider.");
    }

    const {isAuthenticated, isAppInitialized, customerInfo} = context;
    const {pathname, state} = useLocation();

    if (!isAppInitialized) return <LoadingComponent/>;

    if (!isAuthenticated) {
        const from = state?.from?.pathname || pathname;
        return <Navigate
            to={`/sign-in${from !== "/" ? `?redirect_to=${encodeURIComponent(from)}` : ""}`}
            replace
        />;
    }
    if (customerInfo?.user && !customerInfo?.user?.hasPin && !pathname.includes('/set-pin')) {
        const from = state?.from?.pathname || pathname;
        return <Navigate
            to={`/set-pin${from !== "/" ? `?redirect_to=${encodeURIComponent(from)}` : ""}`}
            replace
            state={{ from: pathname }}
        />;
    }

    return <Outlet />;
}